import { Injectable } from '@angular/core';
import { IQuoteLoggable } from '@services/strategy-pattern-login/iQuote-loggable';
import { Observable , of } from 'rxjs';
import { DictionaryCollection } from '@utils/dictionary/dictionary-collection';
import { HttpService } from '@services/http-service';
import { ConfigService } from '@services/webFeeder/config.service';
import { Player } from '@model/webFeeder/player.model';
import { map } from 'rxjs';
import {HttpClient} from '@angular/common/http';
import {environment} from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class IQuotesApiService implements IQuoteLoggable {

  private _dicQuoteQuery: DictionaryCollection<any> = new DictionaryCollection<any>();
  private _player: Player[] = [];
  private timeOutPlayer: any;
  private isRequestPlayerName: boolean;

  constructor(
    private _httpService: HttpService,
    private _httpClient: HttpClient,
    private _configService: ConfigService
  ) {
    // this.loadListPlayer();
  }

  quotesQuery(quote: string, n?: number, showOptions?: boolean, showFractionals?: boolean) {
    if (this._configService.isAuthenticadSystem()) {
      if (quote !== '' && quote !== undefined) {
        quote = quote.trim().replace(' ', '').toLowerCase();
        if (quote.length >= 5) {
          const itemList = this._dicQuoteQuery.item(quote);
          if (itemList && itemList.length > 0) {
            return of(itemList);
          }
        }
        return this._httpClient.get(this._configService.getApiWebFeederRest() +
          '/services/quotes/quotesQuery2?query=' + quote + '&getFractional=true&getOptions=true')
          .pipe(map(response => {
            if (response) {
              this._dicQuoteQuery.add(quote, response);
              return response;
            }
            return undefined;
          }));
      } else {
        return of([]);
      }
    }
  }

  getQuote(quote: string) {
    if (quote) {
      quote = quote.toLowerCase();
      return this._httpService
        .doGet(this._configService.getApiWebFeederRest(), 'services/quotes/quote?query=' + quote.toLowerCase())
        .pipe(map(response => {
          if (response) {
            const json = response;
            return json;
          }
          return [];
        }));
    } else {
      return of();
    }
  }

  getVolumeAtPrice(quote: string, period: number) {
    if (quote) {
      return this._httpClient
        .get(this._configService.getApiWebFeederRest() + '/services/quotes/volumeAtPrice?query='
          + quote.toLowerCase() + '&period=' + period)
        .pipe(map(response => {
          if (response) {
            const json = response;
            return json;
          }
          return [];
        }));
    } else {
      return of();
    }
  }


  loadListPlayer() {
    if (this._configService.isAuthenticadSystem() && this._player.length === 0 && !this.isRequestPlayerName) {
      this.isRequestPlayerName = true;
      this.timeOutPlayer = setTimeout(x => {
        if (this._player.length === 0) {
          this.getListPlayer()
            .subscribe(playerList => {
              if (playerList.length > 0) {
                this._player = playerList;
                clearInterval(this.timeOutPlayer);
              }
              this.isRequestPlayerName = false;
            }, error => {
              this.isRequestPlayerName = false;
            });
        }
      }, 5000);
    }
  }

  public getPlayerName(code: string) {
    if (code && this._player.length > 0) {
      code = code + '';
      const playerResult = this._player.filter(item => item.code === code);
      if (playerResult !== undefined && playerResult.length !== undefined && playerResult.length > 0) {
        return playerResult[0].name;
      }
    } else {
      this.loadListPlayer();
    }
    return code;
  }

  private getListPlayer(): Observable<Player[]> {
    return this._httpService
      .doGet(this._configService.getApiWebFeederRest(), 'services/quotes/playerNames')
      .pipe(map(response => {
        if (response) {
          const playerList = Array<Player>();
          if (response && response.length > 0) {
            response.forEach(element => {
              if (element.playerName !== undefined) {
                playerList.push({
                  code: element.playerMarketCode,
                  name: element.playerName,
                  market: element.marketCode
                });
              }
            });
          }
          return playerList;
        }
        return [];
      }));
  }

}
